var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcInfo = function SvgIcInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icInfo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6C61E",
    fillRule: "evenodd",
    d: "M22.25 12c0-5.661-4.59-10.25-10.25-10.25S1.75 6.339 1.75 12 6.339 22.25 12 22.25 22.25 17.66 22.25 12m-9-4a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-2 2.5a1 1 0 0 0-.25 1.969V16.5a1 1 0 0 0 1 1h.75a1 1 0 0 0 .25-1.969V11.5a1 1 0 0 0-1-1z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icInfo_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })))));
};
export default SvgIcInfo;